(() => {
  'use strict';

  if (window.msxProductReady) return;
  window.msxProductReady = true;

  const initialize = (root) => {
    if (root.dataset.msxReady) return;
    root.dataset.msxReady = 'true';

    let variants;

    try {
      variants = JSON.parse(
        root.querySelector('[data-msx-variant-data]').textContent
      );
    } catch (_) {
      return;
    }

    const inputs = [...root.querySelectorAll('[data-msx-option-input]')];
    const panels = [...root.querySelectorAll('[data-msx-variant-gallery]')];

    const button = root.querySelector('[data-msx-purchase-button]');

    const price = root.querySelector('[data-msx-price]');
    const priceWrap = root.querySelector('[data-msx-price-wrap]');
    const comparePrice = root.querySelector('[data-msx-compare-price]');
    const saleBadge = root.querySelector('[data-msx-sale-badge]');

    const quantity = root.querySelector('[data-msx-quantity-input]');
    const minus = root.querySelector('[data-msx-quantity-minus]');
    const plus = root.querySelector('[data-msx-quantity-plus]');

    const setQuantity = (value) => {
      if (!quantity) return;

      const min = Number(quantity.min || 1);
      const max = Number(quantity.max || Infinity);
      const step = Number(quantity.step || 1);

      quantity.value = String(
        Math.min(
          max,
          Math.max(
            min,
            min +
              Math.floor(
                ((Number(value) || min) - min) / step
              ) *
                step
          )
        )
      );

      if (minus) {
        minus.disabled = Number(quantity.value) <= min;
      }

      if (plus) {
        plus.disabled =
          Number(quantity.value) + step > max;
      }
    };

    minus?.addEventListener('click', () =>
      setQuantity(
        Number(quantity.value) -
          Number(quantity.step || 1)
      )
    );

    plus?.addEventListener('click', () =>
      setQuantity(
        Number(quantity.value) +
          Number(quantity.step || 1)
      )
    );

    quantity?.addEventListener('change', () =>
      setQuantity(quantity.value)
    );

    panels.forEach((panel) => {
      panel
        .querySelectorAll('[data-msx-media-thumb]')
        .forEach((thumb) =>
          thumb.addEventListener('click', () => {
            panel
              .querySelectorAll('[data-msx-media-item]')
              .forEach((item) => {
                const active =
                  item.dataset.mediaId ===
                  thumb.dataset.mediaId;

                item.hidden = !active;
                item.classList.toggle(
                  'is-active',
                  active
                );
              });

            panel
              .querySelectorAll('[data-msx-media-thumb]')
              .forEach((item) => {
                if (item === thumb) {
                  item.setAttribute(
                    'aria-current',
                    'true'
                  );
                } else {
                  item.removeAttribute('aria-current');
                }
              });
          })
        );
    });

    const selected = () => {
      if (!inputs.length) {
        return (
          variants.find(
            (v) =>
              String(v.id) ===
              root.dataset.selectedVariant
          ) || variants[0]
        );
      }

      const values = inputs
        .filter((i) => i.checked)
        .sort(
          (a, b) =>
            Number(a.dataset.optionPosition) -
            Number(b.dataset.optionPosition)
        )
        .map((i) => i.value);

      return variants.find(
        (v) =>
          v.options.length === values.length &&
          v.options.every(
            (value, index) =>
              value === values[index]
          )
      );
    };

    const update = (changeUrl = false) => {
      const variant = selected();

      inputs
        .filter((i) => i.checked)
        .forEach((input) => {
          const label = root.querySelector(
            `[data-msx-option-label="${input.dataset.optionPosition}"]`
          );

          if (label) {
            label.textContent =
              input.dataset.displayLabel ||
              input.value;
          }
        });

      panels.forEach((panel) => {
        panel.hidden =
          !variant ||
          panel.dataset.msxVariantGallery !==
            String(variant.id);
      });

      const hasSale = Boolean(
        variant &&
          variant.compareAtPrice &&
          Number(variant.compareAtPrice) >
            Number(variant.price)
      );

      if (price) {
        price.textContent =
          variant?.formattedPrice || '';

        price.classList.toggle(
          'is-sale',
          hasSale
        );
      }

      if (priceWrap) {
        priceWrap.classList.toggle(
          'is-sale',
          hasSale
        );
      }

      if (comparePrice) {
        comparePrice.textContent = hasSale
          ? variant.formattedCompareAtPrice || ''
          : '';

        comparePrice.classList.toggle(
          'is-hidden',
          !hasSale
        );
      }

      if (saleBadge) {
        let discountPercent = 0;

        if (hasSale) {
          discountPercent = Math.round(
            ((Number(variant.compareAtPrice) -
              Number(variant.price)) /
              Number(variant.compareAtPrice)) *
              100
          );
        }

        saleBadge.textContent = hasSale
          ? `-${discountPercent}%`
          : '';

        saleBadge.classList.toggle(
          'is-hidden',
          !hasSale
        );
      }

      if (button) {
  const marketSoldOut =
    button.dataset.marketSoldOut === 'true';

  const available =
    !!variant &&
    !marketSoldOut &&
    (variant.available ||
      variant.purchase?.mode === 'amazon');

  button.disabled = !available;

        button.setAttribute(
          'aria-disabled',
          String(!available)
        );

        button.dataset.variantId =
          variant?.id || '';

        button.dataset.purchaseMode =
          variant?.purchase?.mode || 'checkout';

        button.dataset.amazonUrl =
          variant?.purchase?.url || '';

        button.dataset.minimumQuantity =
          variant?.minimum || 1;

        const purchaseLabel = button.querySelector(
          '[data-msx-purchase-label]'
        );

        if (purchaseLabel) {
          purchaseLabel.textContent = available
            ? button.dataset.label
            : variant
              ? button.dataset.soldOutLabel
              : root.dataset.unavailableLabel;
        }
      }

      if (quantity && variant) {
        quantity.min = variant.minimum || 1;
        quantity.step = variant.increment || 1;

        if (variant.maximum) {
          quantity.max = variant.maximum;
        } else {
          quantity.removeAttribute('max');
        }

        setQuantity(quantity.value);
      }

      if (changeUrl) {
        const url = new URL(
          window.location.href
        );

        if (variant) {
          url.searchParams.set(
            'variant',
            variant.id
          );
        } else {
          url.searchParams.delete('variant');
        }

        window.history.replaceState(
          {},
          '',
          url
        );
      }

      root
        .querySelector(
          '[data-msx-purchase-error]'
        )
        ?.remove();
    };

    inputs.forEach((input) =>
      input.addEventListener('change', () =>
        update(true)
      )
    );

    update();
  };

  const all = (scope = document) =>
    scope
      .querySelectorAll('[data-msx-product]')
      .forEach(initialize);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => all(),
      { once: true }
    );
  } else {
    all();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => all(event.target)
  );
})();